<template>
  <div class="messageBoardStyle">

    <form>
      <div class="vx-row">
        <div class="vx-col w-full">

          <vue-editor v-model="messageBoard" placeholder="Type Your Message" class="w-full mb-4 mt-5" />


          <!-- <vs-textarea rows="5" v-model="messageBoard" placeholder="Type Your Message" class="w-full mb-4 mt-5" /> -->


          <div class="flex items-center justify-start w-full mb-12">
            <label for="activeToggle" class="flex items-center cursor-pointer">
              <div class="relative">
                <input id="activeToggle" type="checkbox" class="sr-only" v-model="messageBoardStatus"/>
                <div class="w-10 h-6 bg-gray-400 rounded-full shadow-inner" style="background: #b5b5b5;"></div>
                <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
              </div>
              <!-- label -->
              <div class="ml-3 text-gray-700 font-medium">{{messageBoardStatus ? 'Active': 'Inactive'}}</div>
            </label>
          </div>

          <vs-button class="mr-6" @click="updateMessage">Save</vs-button>

        </div>
      </div>
    </form>
    
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor
  },
  data() {
    return {
      messageBoard: '',
      messageBoardId: '',
      messageBoardStatus: '',
    }
  },
  async created() {
    await this.getMessage();
  },
  computed: {
    
  },
  methods: {
    async getMessage() {
      let { data } = await this.$get(`/message-boards`);
      this.messageBoard = data[0].message;
      this.messageBoardId = data[0].id
      this.messageBoardStatus = data[0].status
    },
    updateMessage() {
      this.$update(`/message-boards/${this.messageBoardId}`, {
        message: this.messageBoard,
        status: this.messageBoardStatus
      })
      .then(({ data }) => {
        // console.log(data);
        this.$vs.notify({
            title: 'Success',
            text: 'Message updated successfully',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check',
            position:'bottom-center'
          })
      })
    },
  }
};
</script>

<style lang="scss" scoped>

/* Toggle */
.messageBoardStyle .dot {
  top: 0;
  right: 50%;
}
.messageBoardStyle input:checked ~ .dot {
  transform: translateX(100%) !important;
  background-color: #598d7f !important;
}



</style>
